import SMSClient from '@apps/phone/admin/components/sms_client'
import ModalPanel from '@admin/components/modal_panel'
import PropTypes from 'prop-types'
import React from 'react'

class SMS extends React.Component {

  static propTypes = {
    contact: PropTypes.object,
    contact_phone_number: PropTypes.object,
    contact_phone_numbers: PropTypes.array,
    program_phone_number: PropTypes.object,
    program_phone_numbers: PropTypes.array,
    onBack: PropTypes.func,
    onCancel: PropTypes.func
  }

  _handleBack = this._handleBack.bind(this)
  _handleCancel = this._handleCancel.bind(this)

  render() {
    return (
      <ModalPanel { ...this._getPanel() }>
        <SMSClient { ...this._getSMSClient() } />
      </ModalPanel>
    )
  }

  _getPanel() {
    const { contact_phone_numbers, program_phone_numbers } = this.props
    return {
      title: 't(Conversation)',
      leftItems: contact_phone_numbers.length === 1 && program_phone_numbers.length === 1 ? [
        { label: 'Cancel', handler: this._handleCancel }
      ] : [
        { svg: 'chevron_left', handler: this._handleBack }
      ]
    }
  }

  _getSMSClient() {
    const { contact, contact_phone_number, program_phone_number } = this.props
    return {
      contact,
      program: program_phone_number.program,
      contact_phone_number,
      program_phone_number
    }
  }

  _handleBack() {
    this.props.onBack()
  }

  _handleCancel() {
    this.props.onCancel()
  }

}

export default SMS
